/**
 * Bewegungs-Presets. Eine Quelle für alle Übergänge, damit sich die Oberfläche
 * einheitlich anfühlt: weiche Federn, keine harten Sprünge.
 *
 * Jede Komponente prüft `useReducedMotion()` und verwendet dann `ohneBewegung`.
 */

import type { Transition, Variants } from 'framer-motion';

/** Gleitender Aktiv-Indikator (TabBar, Fortschritt). */
export const federIndikator: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 30,
  mass: 0.9,
};

/** Weiche Feder für Höhen- und Positionsänderungen von Flächen. */
export const federFlaeche: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 32,
  mass: 0.9,
};

/** Kurzer Übergang für Ein-/Ausblenden. */
export const uebergangSanft: Transition = {
  duration: 0.2,
  ease: [0.2, 0.8, 0.2, 1],
};

/** Ersatz-Transition bei reduzierter Bewegung. */
export const ohneBewegung: Transition = { duration: 0 };

export function transition(reduziert: boolean, normal: Transition): Transition {
  return reduziert ? ohneBewegung : normal;
}

/** Seitenwechsel innerhalb der Shell. */
export const seitenVarianten: Variants = {
  eingang: { opacity: 0, y: 8 },
  aktiv: { opacity: 1, y: 0 },
  ausgang: { opacity: 0, y: -6 },
};

/** Schrittwechsel im Wizard, richtungsabhängig (1 = vorwärts, -1 = zurück). */
export const schrittVarianten: Variants = {
  eingang: (richtung: number) => ({ opacity: 0, x: richtung > 0 ? 28 : -28 }),
  aktiv: { opacity: 1, x: 0 },
  ausgang: (richtung: number) => ({ opacity: 0, x: richtung > 0 ? -28 : 28 }),
};
